"use client";

import { useState } from "react";
import Chat from "./Chat";

export default function FloatingChat() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-4 right-4 z-50">
            {/* Chat Window */}
            {isOpen && (
                <div
                    className="absolute bottom-17 right-0 bg-white rounded-2xl shadow-xl border border-gray-100 
		w-[calc(100vw-2rem)] h-[70vh] max-w-sm max-h-[500px]
		sm:w-96 sm:h-[500px] sm:max-w-none sm:max-h-none
		lg:w-[420px] lg:h-[580px]
		animate-in slide-in-from-bottom-2 fade-in-0 duration-300"
                >
                    <Chat onClose={() => setIsOpen(false)} />
                </div>
            )}

            {/* Chat Toggle Button */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="bg-yellow-400 hover:bg-yellow-500 text-white p-3.5 rounded-full shadow-lg transition-all duration-200 hover:shadow-xl hover:scale-105 relative cursor-pointer"
            >
                <div className="relative">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                        />
                    </svg>
                </div>
            </button>
        </div>
    );
}
